import { setRangeMax } from './helpers';

export const setFromMKADMax = setRangeMax('from_mcad_km');
